import axios from 'axios';
import { getLocalStorage, removeLocalStorage } from '../commom/localStorage';
import { GetGaUserCode, GetUserIdCookie } from '../commom/userCode';
import env from '../env';

const axiosInstanceSimuladao = axios.create({
  baseURL: env.REACT_APP_API_URL,
});

const KEY_TOKEN_SIMULADAO = 'token-simuladao';
const KEY_LOGIN_SIMULADAO = 'hasPreviousPageGate';

/*
 *  adiciona o token de autenticação nas requisições
 * */
axiosInstanceSimuladao.interceptors.request.use(
  (config) => {
    const token = getLocalStorage(KEY_TOKEN_SIMULADAO);

    if (token) {
      config.headers.simulationaccesstoken = token;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

/*
 *   adiciona no body das requisições post o uniqueGaId e userIdCookie
 *   dados usados para rastrear atividades dos usuários
 * */
axiosInstanceSimuladao.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        uniqueGaId: GetGaUserCode(),
        userIdCookie: GetUserIdCookie(),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
 * Interceptador de resposta para tratar sessão inválida.
 * 403: token expirado (fluxo antigo do identifyUser).
 * 401: rota protegida por requireAuthenticatedUser sem token válido.
 */
axiosInstanceSimuladao.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      removeLocalStorage(KEY_TOKEN_SIMULADAO);
      // A sessao e compartilhada entre os produtos, mas o login nao: quem esta
      // no ENEM 365 volta para o login do ENEM 365.
      window.location.href = window.location.pathname.startsWith('/enem-365')
        ? '/enem-365/login'
        : '/simuladao/login';
    }
    return Promise.reject(error);
  }
);

export { KEY_TOKEN_SIMULADAO, KEY_LOGIN_SIMULADAO, axiosInstanceSimuladao };

